import FBoolean from './f-boolean'
import FCollections from './f-collections'
import FContentRestrictions from './f-content-restrictions'
import FEmail from './f-email'
import FInteger from './f-integer'
import FMedia from './f-media'
import FModel from './f-model'
import FPassword from './f-password'
import FPhone from './f-phone'
import FSelect from './f-select'
import FSlug from './f-slug'
import FString from './f-string'
import FTags from './f-tags'
import FText from './f-text'
import FTitle from './f-title'
import FUsername from './f-username'
import FUsers from './f-users'
const FOverride = () => import( /* webpackChunkName: "fields" */ './f-override.vue' )

export default {
  FBoolean,
  FCollections,
  FContentRestrictions,
  FEmail,
  FInteger,
  FMedia,
  FModel,
  FOverride,
  FPassword,
  FPhone,
  FSelect,
  FSlug,
  FString,
  FTags,
  FText,
  FTitle,
  FUsername,
  FUsers,
}
